"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandChildren = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ToolbarMenuMore_1 = require("./ToolbarMenuMore");
const ToolbarMenuItem_1 = require("./ToolbarMenuItem");
const ExpandChildren = ({ item, disabled }) => {
    const nodes = [];
    const children = item.children;
    const length = children?.length ?? 0;
    const max = item.expand ?? 5;
    for (let i = 0; i < length && i < max; i++) {
        const child = children[i];
        if (child.icon) {
            nodes.push(React.createElement(ToolbarMenuItem_1.ToolbarMenuItem, { key: child.id || child.name || i, item: child, disabled: disabled }));
        }
    }
    if (length > max) {
        nodes.push(React.createElement(ToolbarMenuMore_1.ToolbarMenuMore, { key: '_more', item: item, disabled: disabled }));
    }
    return React.createElement(React.Fragment, null, nodes);
};
exports.ExpandChildren = ExpandChildren;
